import { BoxProps, Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";

interface ShadowSelectableButtonProps extends BoxProps {
  selected: boolean;
  onUnselect?: () => any;
  selectedColor?: string;
  disabled?: boolean;
  colorText?: string;
}

function ShadowSelectableButton({
  children,
  selected,
  onUnselect,
  disabled,
  selectedColor = colors.primary,
  colorText = colors.primary,
  ...rest
}: ShadowSelectableButtonProps) {
  return (
    <Flex
      rounded={16}
      cursor="pointer"
      px={8}
      py={6}
      boxShadow="0 0 24px rgba(0,0,0,.06)"
      borderColor={selected ? selectedColor : "#00000000"}
      borderWidth={2}
      bgColor={colors.white}
      color={selected ? colorText : colors.black}
      gridGap={2}
      fontSize={16}
      h="fit-content"
      alignItems="center"
      justifyContent="center"
      transition=".1s all linear"
      _hover={{
        opacity: disabled ? 0.5 : 0.8,
        boxShadow: "0 0 16px rgba(0,0,0,.15)",
      }}
      _disabled={{
        opacity: 0.3,
      }}
      {...rest}
    >
      {children}
    </Flex>
  );
}

export default ShadowSelectableButton;
